import { requestJson } from '@/shared/api/http'
import type { AnalyticsDashboardData } from '../model/contracts'

export async function fetchAnalyticsDashboard(
  signal?: AbortSignal,
): Promise<AnalyticsDashboardData> {
  return requestJson<AnalyticsDashboardData>('/api/v1/analytics/dashboard', { signal })
}
